export const CENTER_CIRCLE_OUTPUT_NAMES = Object.freeze([
  'Away RSN',
  'Home RSN',
  'Home RSN (FR)',
  'US National',
  'CA National',
  'CA National (FR)',
]);

export const isCenterCircleOutput = outputName =>
  CENTER_CIRCLE_OUTPUT_NAMES.includes(String(outputName || '').trim());
